package com.kinoshazam.screens.details

import androidx.compose.runtime.Composable
import com.kinoshazam.uiKit.components.videoItem.normalizedRating
import kinoshazam.resources.generated.resources.Res
import kinoshazam.resources.generated.resources.imdb
import kinoshazam.resources.generated.resources.kinoshka
import models.VideoDetails
import org.jetbrains.compose.resources.stringResource

@Composable
fun videoRatingLabel(video: VideoDetails?): String? {
    val imdb = video?.imbdRating.normalizedRating()
    if (imdb != null) return "${stringResource(Res.string.imdb)}: $imdb"
    val kinoshka = video?.kinoshkaRating.normalizedRating()
    if (kinoshka != null) return "${stringResource(Res.string.kinoshka)}: $kinoshka"
    return null
}

@Composable
fun videoYearLabel(video: VideoDetails?): String =
    video?.year?.take(4)?.takeIf { it.length == 4 }.orEmpty()
